<template>
  <div v-if="show">
    <div class="controls" v-if="!loading">
      <div class="icon">
        <img src="/favicon.ico" alt="Photo Permissions from ClassForKids" />
      </div>

      <div>
        <label class="mbn pbn inline field-label">{{ label }}</label>
        <p class="mbn smaller">
          Let us know if you’re happy for pictures & videos to be taken of your child to
          be posted on our social media platforms
        </p>
      </div>

      <div>
        <select
          name="photoPermission"
          id="photoPermission"
          v-model="status"
          @change="toggleSetting"
          data-rule-required="true"
          data-msg-required="Answering this question is compulsory"
        >
          <option disabled value="">Please select</option>
          <option
            v-for="(option, index) in options"
            :value="option.value"
            :key="index"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="text-center" v-else>
      <i class="fal fa-circle-notch fa-spin fa-fw"></i>
    </div>
  </div>
</template>

<script>
'use strict';
export default {
  name: 'PhotoPermission',
  data() {
    return {
      getURL: '/api/v4/people/person/photo-permissions',
      updateURL: '/api/v4/people/person/update-photo-permissions',
      show: true,
      options: [
        {
          value: '1',
          label: 'Yes',
        },
        {
          value: '0',
          label: 'No',
        },
      ],
      status: '',
      loading: true,
    };
  },

  props: {
    personId: {
      required: false,
      type: String,
      default: function () {
        return this.$root.$el.dataset.personId;
      },
    },
    clientId: {
      required: false,
      type: String,
      default: function () {
        return this.$root.$el.dataset.clientId;
      },
    },
    clientName: {
      required: false,
      type: String,
      default: function () {
        return this.$root.$el.dataset.clientName;
      },
    },
  },

  methods: {
    async getSetting() {
      try {
        this.loading = true;
        const url = this.getURL;
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({
            personId: this.personId,
          }),
        });

        const setting = await fetch(request);
        const settingJson = await setting.json();

        this.loading = false;
        if (settingJson.error) {
          this.show = false;
        } else if (settingJson.data) {
          this.status = settingJson.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async toggleSetting() {
      try {
        this.loading = true;
        const url = this.updateURL;
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({
            personId: this.personId,
            status: this.status,
            clientId: this.clientId,
          }),
        });
        const statusRequest = await fetch(request);
        const statusJson = await statusRequest.json();

        this.loading = false;
        if (statusJson.error) {
          this.show = false;
        } else if (statusJson.data) {
          this.status = statusJson.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    parseStatus(response) {
      if (response == 0) {
        this.status = false;
      } else if (response == 1) {
        this.status = true;
      } else {
        this.status = response;
      }
    },
  },

  computed: {
    label() {
      return this.clientName
        ? `Photo & Video Permissions for ${this.clientName}`
        : 'Photo & Video Permissions';
    },
  },

  components: {},

  beforeMount() {},

  mounted() {
    this.getSetting();
  },
  created() {},
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

h6 {
  font-size: 0.7rem;
  color: #737373;
}

.icon {
  text-align: center;
}

.controls {
  display: grid;
  /*grid-template-columns: 1fr 1fr;*/
  grid-template-columns: 2fr 6fr 4fr;
  gap: 8px;
  align-items: center;
}

#photoPermission {
  margin-bottom: 0;
}

.switch {
  text-align: right;
}
</style>
